import { Component, OnInit } from '@angular/core';
import { Constants } from '../common/constants';

@Component({
  selector: 'app-accessdenied',
  templateUrl: './accessdenied.component.html'
})

export class AccessDeniedComponent implements OnInit {
  Heading: string = "";
  Information: string = "";

  constructor() {
    /*No code*/
  }

  ngOnInit() {
    this.Heading = Constants.AccessDeniedHeading;
    this.Information = Constants.AccessDeniedInformation;
  }

}
